import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { getCheckoutUrl } from '../utils/getCheckoutUrl';
import { trackAddToCart } from '../utils/metaPixel';
const MAIN_PRICE = 4.99;
const BUMP_PRICES: Record<string, number> = {
  ia: 2.99,
  mensajes: 2.99,
  clientes: 2.99
};
interface FinalCTAProps {
  addedBumps: Record<string, boolean>;
}
export function FinalCTA({
  addedBumps
}: FinalCTAProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const bumpTotal = Object.entries(addedBumps).reduce((sum, [id, added]) => sum + (added ? BUMP_PRICES[id] || 0 : 0), 0);
  const total = MAIN_PRICE + bumpTotal;
  return <section ref={ref} className="py-32 px-6 bg-dark-secondary relative overflow-hidden" data-id="element-31">
      {/* Background glow */}
      <div className="absolute inset-0 flex items-center justify-center" data-id="element-32">
        <div className="w-96 h-96 bg-accent/5 rounded-full blur-3xl" data-id="element-33" />
      </div>

      
    </section>;
}